module.exports = __webpack_public_path__ + "media/berlin/universities-map-berlin-8552567b.webp";